import { useContext } from 'react';
import AddBlack from '../../../Assets/PlusIcon/AddBlack.svg';
import { InventoryEditProductFormContext } from '../../../Context/InventoryEditProductFormContext';
import { useDispatch } from 'react-redux';
import { setModal } from '../../../Features/inventoryManagementSlice';
import Input from '../../../Components/Input/Input';

function Specification({ selectedCategory1, selectedCategory2 }) {
    const dispatch = useDispatch();

    const {
        specifications,
        setSpecifications,
        productSpecifications,
        setProductSpecifications,
        additionalSpecifications,
        setAdditionalSpecifications,
        formErrors
    } = useContext(InventoryEditProductFormContext);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSpecifications({ ...specifications, [name]: value });
    }

    const handleProductSpecificationsChange = (e) => {
        const { name, value } = e.target;
        setProductSpecifications(prevSpecs => 
            prevSpecs.map(spec => spec.id === name ? { ...spec, value } : spec)
        )
    }

    const handleAdditionalSpecificationsChange = (e) => {
        const { name, value } = e.target;
        setAdditionalSpecifications(prevSpecs => 
            prevSpecs.map(spec => spec.id === name ? { ...spec, value } : spec)
        )
    }

    const handleAddCustomField = () => {
        dispatch(setModal('add-custom-field'));
    }

    return (
        <div className="flex flex-col gap-3 border border-[#EAEAEA] p-5 rounded-xl">
            <h1 className='font-semibold text-[18px] leading-[26px]'>Specification</h1>

            <div className="grid grid-cols-2 gap-x-2 gap-y-3">
                <Input 
                    labelText='Color' 
                    errorText={formErrors.color} 
                    inputOptions={{
                        type: 'text',
                        id: 'color',
                        name: 'color',
                        value: specifications.color,
                        onChange: handleChange
                    }}
                    required={selectedCategory1 !== 'Beauty & Personal Care'}
                />

                <Input 
                    labelText={selectedCategory1 === 'Beauty & Personal Care' ? 'Volume' : 'Size'} 
                    errorText={formErrors.size} 
                    inputOptions={{
                        type: 'text',
                        id: 'size',
                        name: 'size',
                        value: specifications.size,
                        onChange: handleChange
                    }}
                    required
                />

                {productSpecifications?.map(field => {
                    const required = field.id === 'volume';

                    return (
                        <Input 
                            key={field.id} 
                            labelText={field.labelText} 
                            inputOptions={{
                                type: 'text',
                                id: field.id,
                                name: field.id,
                                value: field.value,
                                onChange: handleProductSpecificationsChange
                            }} 
                            required={required}
                        />
                    );
                })}

                {additionalSpecifications.map(field => {
                    return (
                        <Input 
                            key={field.id} 
                            labelText={field.labelText} 
                            inputOptions={{
                                type: 'text',
                                id: field.id,
                                name: field.id,
                                value: field.value,
                                onChange: handleAdditionalSpecificationsChange
                            }}
                        />
                    );
                })}
            </div>

            <button onClick={handleAddCustomField} className="py-[10px] flex gap-1 w-fit">
                <div className="w-6 h-6 flex items-center justify-center">
                    <img src={AddBlack} alt="" />
                </div>

                <p className='font-semibold text-base text-primaryColor'>Add custom field</p>
            </button>
        </div>
    );
}

export default Specification;
